<template>
    <div>
        <Pane>
            <span>票据使用</span>
        </Pane>
        <div class="container">
            <a-form-model
                ref="useForm"
                :model="formData"
                :rules="rules"
                :label-col="{ span: 8 }"
                :wrapper-col="{ span: 12 }"
                :colon="false"
            >
                <!-- 票据信息 只读展示区 -->
                <div class="title">票据信息</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="票据号码">
                                <span>{{ billInfo.billNo || '-' }}</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="所属银行">
                                <span>{{ bankNameEcho }}</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="上手背书人">
                                <span>{{ billInfo.prevEndorser || '-' }}</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="票据金额">
                                <span>{{ formatAmount(billInfo.amount) }} 元</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="票据类型">
                                <span>{{ billTypeName }}</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="出票人">
                                <span>{{ billInfo.drawer || '-' }}</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="到期日">
                                <span class="red-text">{{ billInfo.dueDate || '-' }}</span>
                            </a-form-model-item>
                        </a-col>
                        <a-col  :lg="12" :md="12" :sm="24" style="height: 35px;">
                            <a-form-model-item label="当前余额">
                                <span>{{ formatAmount(billInfo.inHandAmount) }} 元</span>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>

                <!-- 使用信息 动态表单区 -->
                <div class="title">使用信息</div>
                <div class="wrapper">
                    <a-row>
                        <!-- 使用方法下拉，billUseType 字典回显，控制切换 -->
                        <a-col :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="使用方法" prop="useType">
                                <a-select v-model="formData.useType" placeholder="请选择使用方法" @change="onUseTypeChange">
                                    <a-select-option v-for="item in billUseTypeList" :key="item.value" :value="item.value">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                        <!-- 背书转让 ENDORSE -->
                        <template v-if="matchUseType('ENDORSE')">
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="使用金额" prop="useAmount">
                                    <a-input-number
                                        v-model="formData.useAmount"
                                        style="width:100%"
                                        :min="0"
                                        :max="billInfo.inHandAmount"
                                    >
                                        <template #suffix>元</template>
                                    </a-input-number>
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="下手背书人" prop="nextEndorsee">
                                    <a-input v-model="formData.nextEndorsee" placeholder="请输入下手背书人" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="关联项目">
                                    <ContractSelector @change="onSelectProject">
                                        <a-button block style="text-align: left" class="ellipsis">
                                            {{ formData.relContractName }}
                                        </a-button>
                                    </ContractSelector>
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="关联付款申请单">
                                    <a-input
                                        :value="formData.paymentApplicationId"
                                        placeholder="请选择关联付款申请单"
                                        read-only
                                        allow-clear
                                        @click="openPayApplyModal"
                                        @change="onPayApplyClear"
                                    />
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="使用日期">
                                    <a-date-picker v-model="formData.useDate" style="width:100%" value-format="YYYY-MM-DD" placeholder="请选择日期" />
                                </a-form-model-item>
                            </a-col>
                        </template>

                        <!-- 托收兑付 COLLECTION -->
                        <template v-if="matchUseType('COLLECTION')">
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="托收金额" prop="collectAmount">
                                    <a-input-number
                                        v-model="formData.collectAmount"
                                        style="width:100%"
                                        :min="0"
                                        :max="billInfo.inHandAmount"
                                    >
                                        <template #suffix>元</template>
                                    </a-input-number>
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="托收日期" prop="collectDate">
                                    <a-date-picker v-model="formData.collectDate" style="width:100%" value-format="YYYY-MM-DD" placeholder="请选择日期" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="托收银行" prop="collectionBank">
                                    <a-select
                                        v-model="formData.collectionBank"
                                        placeholder="请选择托收银行"
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        allow-clear
                                    >
                                        <a-select-option v-for="item in bankList" :key="item.value" :value="item.value">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </template>

                        <!-- 贴现 DISCOUNT -->
                        <template v-if="matchUseType('DISCOUNT')">
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="贴现金额" prop="discountAmount">
                                    <a-input-number
                                        v-model="formData.discountAmount"
                                        style="width:100%"
                                        :min="0"
                                        :max="billInfo.inHandAmount"
                                    >
                                        <template #suffix>元</template>
                                    </a-input-number>
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="贴现日期" prop="discountDate">
                                    <a-date-picker v-model="formData.discountDate" style="width:100%" value-format="YYYY-MM-DD" placeholder="请选择日期" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="贴现银行" prop="discountBank">
                                    <a-select
                                        v-model="formData.discountBank"
                                        placeholder="请选择贴现银行"
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        allow-clear
                                    >
                                        <a-select-option v-for="item in bankList" :key="item.value" :value="item.value">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-model-item label="贴现手续费">
                                    <a-input-number v-model="formData.discountFee" style="width:100%" :min="0" />
                                </a-form-model-item>
                            </a-col>
                        </template>

                        <!-- 使用后余额（只读蓝色，所有模式都有） -->
                        <a-col  :lg="12" :md="12" :sm="24">
                            <a-form-model-item label="使用后余额" class="balance-row">
                                <span class="blue-amount">{{ afterBalanceStr }} 元</span>
                            </a-form-model-item>
                        </a-col>
                        <!-- 备注 全部模式共用 -->
                        <a-col :span="24">
                            <a-form-model-item :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" label="备注">
                                <a-textarea v-model="formData.remarks" :rows="4" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>

                <!-- 附件上传区域 -->
                <div class="title">附件</div>
                <div class="wrapper">
                    <a-row>
                        <a-col :lg="24" :md="24" :sm="24">
                            <a-form-model-item :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" label="上传">
                                <FileUpload :multiple="true" @uploaded="uploaded">
                                    <a-button type="primary">附件上传</a-button>
                                </FileUpload>

                                <Padding />

                                <a-table bordered :data-source="fileList" :pagination="false" rowKey="id">
                                    <a-table-column title="文件名">
                                        <template slot-scope="text">
                                            <a :href="text.completePath" target="_blank">{{ text.name }}</a>
                                        </template>
                                    </a-table-column>
                                    <a-table-column title="操作" align="center" width="80px">
                                        <template slot-scope="text, record, index">
                                            <a href="#" class="danger" @click.prevent="remove(index)">删除</a>
                                        </template>
                                    </a-table-column>
                                </a-table>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>

                <!-- 底部按钮：取消左，确认使用右 -->
                <div class="center">
                    <a-space>
                        <a-button @click="handleCancel">取消</a-button>
                        <a-button type="primary" :loading="saving" @click="handleSubmit">确认使用</a-button>
                    </a-space>
                </div>
            </a-form-model>
        </div>

        <!-- 关联付款申请单选择弹框 -->
        <a-modal
            title="选择付款申请单"
            :visible="payApplyModalVisible"
            width="60%"
            :destroy-on-close="true"
            @ok="handlePayApplyOk"
            @cancel="payApplyModalVisible = false"
        >
            <a-table
                :columns="payApplyColumns"
                :data-source="payApplyList"
                :loading="payApplyLoading"
                :pagination="payApplyPagination"
                row-key="id"
                size="small"
                bordered
                :scroll="{ x: 1380 }"
                :custom-row="payApplyCustomRow"
                :row-class-name="payApplyRowClassName"
                @change="handlePayApplyTableChange"
            >
                <template slot="paymentStatus" slot-scope="text">
                    <a-tag :color="getPaymentStatusColor(text)">
                        {{ getPaymentStatusText(text) }}
                    </a-tag>
                </template>
            </a-table>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { fetchBillDetail, billUse } from "@/api/finance/bill-library";
import { fetchPaymentList } from "@/api/finance/payment";
import ContractSelector from "@/components/contract-selector";
import FileUpload from "@/components/file-upload";

export default {
    name: "BillUseForm",
    components: {
        ContractSelector,
        FileUpload
    },
    data() {
        return {
            billId: this.$route.query.id,
            saving: false,
            // 票据只读信息，接口回传
            billInfo: {},
            formData: {
                useType: "",
                // 背书转让
                useAmount: null,
                nextEndorsee: "",
                relContractId: null,
                relContractName: "",
                paymentApplicationId: "",
                useDate: null,
                // 托收
                collectAmount: null,
                collectDate: null,
                collectionBank: null,
                // 贴现
                discountAmount: null,
                discountDate: null,
                discountBank: null,
                discountFee: null,
                remarks: ""
            },
            fileList: [],
            // 付款申请单选择弹框
            payApplyModalVisible: false,
            payApplyList: [],
            payApplyLoading: false,
            payApplySelectedRow: null,
            payApplyColumns: [
                {
                    title: '状态',
                    dataIndex: 'paymentStatus',
                    key: 'paymentStatus',
                    width: 100,
                    scopedSlots: { customRender: 'paymentStatus' }
                },
                { title: '付款日期', dataIndex: ['bankTransaction', 'transactionDate'], key: 'transactionDate', width: 120 },
                { title: '对方户名', dataIndex: 'receiverBankAccountName', key: 'receiverBankAccountName', width: 200 },
                { title: '付款备注', dataIndex: 'paymentDescription', key: 'paymentDescription', width: 150 },
                { title: '项目名称', dataIndex: 'contractName', key: 'contractName', width: 200 },
                { title: '分包名称', dataIndex: 'subpackageName', key: 'subpackageName', width: 150 },
                { title: '分类', dataIndex: 'category', key: 'category', width: 120 },
                { title: '支出(元)', key: 'expenditure', width: 100, align: 'right', customRender: (text, record) => {
                        // 根据paymentType判断使用哪个字段
                        const paymentType = record.paymentType;
                        if (paymentType === 'branch_institute') {
                            // 分院使用actualPaymentAmount
                            return record.actualPaymentAmount || 0;
                        } else {
                            // 总院使用currentPaymentAmount
                            return record.currentPaymentAmount || 0;
                        }
                    } },
                { title: '付款银行', dataIndex: 'receiverBankName', key: 'receiverBankName', width: 120 },
                { title: '责任部门', dataIndex: 'deptName', key: 'deptName', width: 120 }
            ],
            payApplyPagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                showTotal: total => `共 ${total} 条`
            },
            rules: {
                useType: [{ required: true, message: "请选择使用方法", trigger: "change" }],
                // 背书转让
                useAmount: [{ required: true, message: "请输入使用金额", trigger: "blur" }],
                nextEndorsee: [{ required: true, message: "请输入下手背书人", trigger: "blur" }],
                // useDate: [{ required: true, message: "请选择使用日期", trigger: "change" }],
                // 托收兑付
                collectAmount: [
                    { required: true, message: "请输入托收金额", trigger: "blur" },
                    {
                        validator: (rule, value, callback) => {
                            if (value != null && Number(value) !== Number(this.billInfo.inHandAmount || 0)) {
                                callback(new Error("托收金额须等于在手余额"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    }
                ],
                collectDate: [{ required: true, message: "请选择托收日期", trigger: "change" }],
                collectionBank: [{ required: true, message: "请选择托收银行", trigger: "change" }],
                // 贴现
                discountAmount: [{ required: true, message: "请输入贴现金额", trigger: "blur" }],
                discountDate: [{ required: true, message: "请选择贴现日期", trigger: "change" }],
                discountBank: [{ required: true, message: "请选择贴现银行", trigger: "change" }]
            }
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict", "findSingleDictName"]),
        ...mapState("auth", ["user"]),
        bankList() {
            return this.findDataDict("bank") || [];
        },
        billUseTypeList() {
            return this.findDataDict("billUseType") || [];
        },
        billTypeName() {
            return this.billInfo.billTypeName || this.findSingleDictName("billType", this.billInfo.billType) || this.billInfo.billType || '-';
        },
        bankNameEcho() {
            return this.findSingleDictName("bank", this.billInfo.bankName) || this.billInfo.bankName || '-';
        },
        // 自动计算使用后余额 +千分位格式化
        afterBalanceStr() {
            const ori = Number(this.billInfo.inHandAmount || 0);
            let useVal = 0;
            if (this.matchUseType("ENDORSE")) useVal = Number(this.formData.useAmount || 0);
            if (this.matchUseType("COLLECTION")) useVal = Number(this.formData.collectAmount || 0);
            if (this.matchUseType("DISCOUNT")) useVal = Number(this.formData.discountAmount || 0);
            const result = ori - useVal;
            return result.toLocaleString('zh-CN', { minimumFractionDigits:2, maximumFractionDigits:2 });
        }
    },
    mounted() {
        this.loadDetail();
    },
    methods: {
        getPaymentStatusColor(status) {
            const colorMap = {
                '已支付': 'green',
                '未支付': 'orange',
                '审批中': 'blue'
            };
            return colorMap[status] || 'default';
        },
        getPaymentStatusText(status) {
            return status;
        },
        //判断当前使用方式（大小写不敏感，避免字典值大小写不一致导致表单不切换）
        matchUseType(type) {
            const t = String(this.formData.useType || '').trim().toUpperCase();
            return t === type;
        },
        formatAmount(value) {
            return value != null && value !== '' ? Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
        },
        async loadDetail() {
            try {
                const res = await fetchBillDetail(this.billId) || {};
                this.billInfo = res;
            } catch (e) {
                console.error("加载票据详情失败", e);
            }
        },
        //切换使用方式清空其他表单字段
        onUseTypeChange() {
            //清空背书
            this.formData.useAmount = null;
            this.formData.nextEndorsee = "";
            this.formData.relContractId = null;
            this.formData.relContractName = "";
            this.formData.paymentApplicationId = "";
            this.formData.useDate = null;
            //清空托收
            this.formData.collectAmount = null;
            this.formData.collectDate = null;
            this.formData.collectionBank = null;
            //清空贴现
            this.formData.discountAmount = null;
            this.formData.discountDate = null;
            this.formData.discountBank = null;
            this.formData.discountFee = null;
        },
        // 选择关联项目
        onSelectProject(project) {
            this.formData.relContractId = project.id;
            this.formData.relContractName = project.name;
        },
        // ==================== 关联付款申请单弹框 ====================
        openPayApplyModal() {
            this.payApplySelectedRow = null;
            this.payApplyModalVisible = true;
            this.payApplyPagination.current = 1;
            this.loadPayApplyList();
        },
        loadPayApplyList() {
            this.payApplyLoading = true;
            fetchPaymentList({
                pageNum: this.payApplyPagination.current,
                pageSize: this.payApplyPagination.pageSize
            })
                .then((res) => {
                    if (Array.isArray(res)) {
                        this.payApplyList = res;
                        this.payApplyPagination.total = res.length;
                    } else if (res) {
                        this.payApplyList = res.list || [];
                        this.payApplyPagination.total = res.totalSize || 0;
                    }
                })
                .finally(() => {
                    this.payApplyLoading = false;
                });
        },
        handlePayApplyTableChange(pagination) {
            this.payApplyPagination = { ...this.payApplyPagination, ...pagination };
            this.loadPayApplyList();
        },
        payApplyCustomRow(record) {
            return {
                on: {
                    click: () => {
                        this.payApplySelectedRow = record;
                    }
                }
            };
        },
        payApplyRowClassName(record) {
            return this.payApplySelectedRow && this.payApplySelectedRow.id === record.id
                ? "ant-table-row-selected"
                : "";
        },
        handlePayApplyOk() {
            if (!this.payApplySelectedRow) {
                this.$message.warning("请选择一条付款申请单");
                return;
            }
            // 回显付款申请单ID
            this.formData.paymentApplicationId = this.payApplySelectedRow.id;
            this.payApplyModalVisible = false;
        },
        // 清除已选付款申请单
        onPayApplyClear(e) {
            if (!e.target.value) {
                this.formData.paymentApplicationId = "";
            }
        },
        // ==================== 附件 ====================
        // 附件上传完成（FileUpload 自动上传后回传文件信息）
        uploaded(list) {
            this.fileList = [...this.fileList, ...list];
        },
        remove(index) {
            this.fileList.splice(index, 1);
        },
        handleCancel() {
            this.$router.back();
        },
        handleSubmit() {
            this.$refs.useForm.validate((valid) => {
                if (!valid) return;
                const f = this.formData;
                const data = {
                    billId: this.billId,
                    useType: f.useType,
                    operatorId: this.user.id,
                    operatorName: this.user.name,
                    // 背书转让
                    nextEndorsee: f.nextEndorsee || undefined,
                    contractId: f.relContractId || undefined,
                    paymentApplicationId: f.paymentApplicationId || undefined,
                    // 托收兑付
                    collectionBank: f.collectionBank || undefined,
                    // 贴现
                    discountBank: f.discountBank || undefined,
                    discountFee: f.discountFee != null ? f.discountFee : undefined,
                    // 公共
                    remarks: f.remarks,
                    attachments: this.fileList.map(item => item.id).join(","),
                    useAmount: null,
                    useDate: null
                };
                // 使用金额、使用日期按使用方式映射（托收须等于在手余额，规则已校验）
                if (this.matchUseType("ENDORSE")) {
                    data.useAmount = f.useAmount;
                    data.useDate = f.useDate;
                } else if (this.matchUseType("COLLECTION")) {
                    data.useAmount = f.collectAmount;
                    data.useDate = f.collectDate;
                } else if (this.matchUseType("DISCOUNT")) {
                    data.useAmount = f.discountAmount;
                    data.useDate = f.discountDate;
                }
                this.saving = true;
                billUse(data)
                    .then(() => {
                        this.$message.success("票据使用提交成功");
                        this.$router.back();
                    })
                    .catch((e) => {
                        console.error("票据使用提交失败", e);
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    text-align:center;
}

.info-item {
    display: flex;
    margin-bottom: 8px;
    padding-right: 24px;
}

.info-item .label {
    width: 90px;
    color: #666;
}

.info-item .value {
    flex: 1;
}

.red-text {
    color: #f5222d;
}

.balance-row {
    padding: 8px 0;
}

.blue-amount {
    color: #1890ff;
    font-weight: bold;
}
</style>
